<div class="station" [ngClass]="pageKlasses">
  <kexp-breadcrumbs></kexp-breadcrumbs>
  <router-outlet></router-outlet>
  <kexp-now-player></kexp-now-player>
</div>

@if (showPlaybackModal()) {
  <pv2-modal-play-button (playClicked)="modalPlay()"></pv2-modal-play-button>
}
